import React, { FC } from 'react'
import Image from 'next/image'

import { StepProps } from '../../StepCard'
import { TagProps } from '../../Tag'
import { HighlightProps } from '../../Highlight'
import { Icons } from '../../Icon'
import { FamilyProfile } from '../../../types'
import {
  getBackgroundImageByFamilyProfile,
  getTagBackgroundColorByFamilyProfile,
} from '../../../models/Family/FamilyHelpers'

import * as SC from './styled'

export type StepCardProps = StepProps & {
  className?: string
  highlightTitleProps?: HighlightProps
  tag?: TagProps
  index?: number
}

const StepCard: FC<StepCardProps> = (props) => {
  const {
    className,
    text,
    familyStepProps,
    tag,
    index,
    highlightTitleProps,
    imageProps,
  } = props

  return (
    <SC.Container
      className={className}
      backgroundColor={getTagBackgroundColorByFamilyProfile(
        familyStepProps?.familyProfile as FamilyProfile
      )}
    >
      <SC.Background icon={Icons.familyStepBackground} />
      {tag && <SC.Tag {...tag} />}
      {highlightTitleProps && <SC.Title {...highlightTitleProps} />}
      {index && <SC.StepNumber>{index}</SC.StepNumber>}
      {familyStepProps?.stepProps.tagProps && (
        <SC.TagAge {...familyStepProps?.stepProps.tagProps} />
      )}
      <SC.Text>{text}</SC.Text>
      {imageProps && (
        <SC.StepImage>
          <Image {...imageProps} />
        </SC.StepImage>
      )}
      <SC.BackgroundImage
        $children={familyStepProps?.familyProfile !== FamilyProfile.PARENT}
      >
        <Image
          alt="Background image"
          src={getBackgroundImageByFamilyProfile(
            familyStepProps?.familyProfile as FamilyProfile
          )}
          layout="fill"
        />
      </SC.BackgroundImage>
    </SC.Container>
  )
}

export default StepCard
